import { useMutation } from '@tanstack/react-query'
import { UserController } from 'src/controllers/user.controller'

const userController = new UserController()

interface SendConfirmationCodeParams {
  username: string
  tipo: 'TELEFONE' | 'EMAIL'
}

export function useSendConfirmationCode() {
  return useMutation<void, Error, SendConfirmationCodeParams>({
    mutationKey: ['sendConfirmationCode'],
    mutationFn: ({ username, tipo }) => userController.sendConfirmationCode(username, tipo)
  })
}
